import { render, staticRenderFns } from "./ReviewYourAnswersCSV.vue?vue&type=template&id=348ff947"
import script from "./ReviewYourAnswersCSV.vue?vue&type=script&lang=ts"
export * from "./ReviewYourAnswersCSV.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports